import axios from "axios";
import { header } from "./header";


export const getModuleList = async(obj) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetModulesListWithCost`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }

  export const addModulesForOrganisation = async(payload) => {
    try{
     const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgAPI/AddModulesForOrganisation`,payload,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }